import { render, staticRenderFns } from "./sessions-table.vue?vue&type=template&id=160b65aa"
import script from "./sessions-table.vue?vue&type=script&lang=js"
export * from "./sessions-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports